import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  cdRoot: {
    borderRadius: theme.spacing(0.5),
    overflow: "scroll",
    background: "transparent"
  },

  title: {
    width: "100%",
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
    fontFamily: "Courier Prime",
    textAlign: "center"
  },

  cdHeader: {
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
    background: theme.palette.background.defaultGradient
  },
  cdAvatar: {
    width: 100,
    height: 100,
    marginRight: theme.spacing(1),
    borderRadius: "50%",
    border: `2px solid ${theme.palette.primary.main}`,
    backgroundImage: ({ companyDetail }) =>
      companyDetail && `url(${companyDetail.avatar})`,
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    boxShadow: theme.customShadows(theme.palette.primary.main),
    background: "white"
  },

  cdDescription: {
    padding: theme.spacing(2),
    "& p": {
      fontSize: theme.typography.body1.fontSize,
      lineHeight: theme.spacing(0.3)
    }
  },

  cdCampaigns: {
    padding: theme.spacing(0)
  }
}));
